import styled from '@emotion/styled';

const TabContainer = styled.div`
  grid-column: span 12 / span 12;
`;

export { TabContainer };
